import React, { useState } from "react"
import { withRouter } from "react-router-dom"

import styled, { css } from "styled-components"
import { Col, Dot } from "../../../../../styles/styles"
import Link from "../../../../Links"
import Button from "../../../../Buttons"
import ReactMoment from "react-moment"
import { graphqlUrl } from "../../../../../Config/Env"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLockAlt, faGift } from "@fortawesome/pro-light-svg-icons"
import {
  faCommentAlt,
  faCommentAltCheck,
} from "@fortawesome/pro-regular-svg-icons"
import nl2br from "react-nl2br"

const SItem = styled.div`
  ${({ theme }) => {
    return css`
      .inquiry_header {
        display: flex;
        flex-direction: row;
        padding: 0 ${theme.paddings.base} ${theme.margins.sm};
        dl {
          display: flex;
          flex: 1;
          flex-direction: column;
          dt {
            span {
              display: inline-block;
              border-radius: 3px;
              color: ${theme.colors.black04};
              font-size: 1rem;
            }
          }
          dd {
            display: flex;
            flex-direction: row;
            align-items: center;
            position: relative;
            font-size: ${theme.fonts.size.sm};
            color: #666;
            span {
              color: #ddd;
              margin-right: ${theme.margins.sm};
              color: ${theme.colors.black03};
              &.active {
                color: ${theme.colors.primary};
              }
            }
          }
        }
        .arrow {
          ::before {
            content: "\f106";
            font-family: ${theme.fonts.family.fontAwesomeL};
            font-size: ${theme.fonts.size.lg};
            color: ${theme.colors.black01};
          }
          &.open {
            ::before {
              content: "\f107";
              color: #bbb;
            }
          }
        }
        .text {
          margin: ${theme.margins.sm} 0;
          font-size: ${theme.fonts.size.sm};
          color: ${theme.colors.black03};
        }
      }
      .inquiry_body {
        padding: ${theme.paddings.base};
        .textBox {
          background-color: #fbfbfb;
          border-left: solid 2px ${theme.colors.primary};
          padding: ${theme.paddings.base};
        }
        .text {
          font-size: ${theme.fonts.size.sm};
          color: ${theme.colors.black03};
        }
      }
      .hide {
        display: none;
      }
    `
  }}
`

function Item({ history, match, location, item, uri, onDelete }) {
  const [isDetail, setIsDetail] = useState(false)
  const toggleView = () => {
    setIsDetail(!isDetail)
  }
  const avatarImage =
    item.user.avatar === "" || item.user.avatar === null
      ? "/assets/img/user/user-default.jpg"
      : `${graphqlUrl}${item.user.avatar}`

  return (
    <SItem>
      <div onClick={toggleView}>
        <div className="inquiry_header">
          <dl>
            <dt>
              {!item.isSecret || (item.isSecret && item.isMe) ? (
                <>
                  <div className="text">{nl2br(item.question)}</div>
                </>
              ) : (
                <div className="text">
                  <FontAwesomeIcon icon={faLockAlt} />
                  &nbsp;비밀문의 입니다.
                </div>
              )}
            </dt>
            <dd>
              <Col left>
                {item.commonStatus === "S" && <span>답변대기</span>}
                {item.commonStatus === "C" && (
                  <span className="active">답변완료</span>
                )}
                <Dot />
                {item.user.name}
                <Dot />
                <ReactMoment format="YYYY. MM. DD">
                  {item.createdAt}
                </ReactMoment>
              </Col>
              {item.commonStatus === "C" &&
                (!item.isSecret || (item.isSecret && item.isMe)) && (
                  <span className={`arrow ${!isDetail && `open`}`}></span>
                )}
            </dd>
          </dl>
        </div>
        {(!item.isSecret || (item.isSecret && item.isMe)) && (
          <div className={`inquiry_body ${!isDetail && `hide`}`}>
            <div className="textBox">
              {item.commonStatus === "C" && (
                <div className="text">{nl2br(item.answer)}</div>
              )}
              {item.isMe && (
                <Col right>
                  <Link
                    to={`/products/${item.ticketProduct.id}/inquiries/${item.id}/edit?redirect=${uri}`}
                    color="white"
                    size="xs"
                    border="radius"
                  >
                    수정
                  </Link>
                  <Button
                    style={{ marginLeft: 5 }}
                    type="button"
                    color="white"
                    size="xs"
                    border="radius"
                    onClick={() => onDelete(item.id)}
                  >
                    삭제
                  </Button>
                </Col>
              )}
            </div>
          </div>
        )}
      </div>
    </SItem>
  )
}
export default withRouter(Item)
